import React from 'react';
import styled from 'styled-components';
import { FaCalendarAlt, FaRupeeSign, FaGlobe, FaClock, FaUserClock } from 'react-icons/fa';
import Button from '../common/Button';

const OverviewSection = styled.section`
  padding: 80px 0;
`;

const CourseInfoBox = styled.div`
  display: flex;
  background-color: white;
  border-radius: ${props => props.theme.borders.radius.regular};
  overflow: hidden;
  box-shadow: ${props => props.theme.shadows.regular};
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    flex-direction: column;
  }
`;

const CourseImage = styled.div`
  flex: 1;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  @media (max-width: ${props => props.theme.breakpoints.md}) {
    height: 300px;
  }
`;

const CourseDetails = styled.div`
  flex: 1;
  padding: 40px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    padding: 30px 20px;
  }
`;

const CourseTitle = styled.h2`
  font-size: ${props => props.theme.fontSizes.xxlarge};
  margin-bottom: 10px;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    font-size: ${props => props.theme.fontSizes.xlarge};
  }
`;

const CourseDescription = styled.p`
  color: ${props => props.theme.colors.grey[600]};
  margin-bottom: 30px;
`;

const CourseMeta = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 30px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
    gap: 15px;
  }
`;

const MetaItem = styled.div`
  display: flex;
  align-items: center;
`;

const MetaIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(52, 152, 219, 0.1);
  color: ${props => props.theme.colors.primaryColor};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin-right: 15px;
  flex-shrink: 0;
`;

const MetaContent = styled.div``;

const MetaTitle = styled.h4`
  margin-bottom: 5px;
  font-size: ${props => props.theme.fontSizes.small};
  color: ${props => props.theme.colors.grey[600]};
`;

const MetaValue = styled.p`
  font-weight: ${props => props.theme.fontWeights.semiBold};
  color: ${props => props.theme.colors.secondaryColor};
`;

const CourseAction = styled.div`
  display: flex;
  gap: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
  }
`;

const CourseOverview = () => {
  return (
    <OverviewSection>
      <div className="container">
        <CourseInfoBox>
          <CourseImage>
            <img src="/placeholder/600/400" alt="TNPSC Exam Coaching" />
          </CourseImage>
          
          <CourseDetails>
            <CourseTitle>TNPSC Exam Coaching Program</CourseTitle>
            <CourseDescription>
              Comprehensive coaching for Junior Draughting Officer & Overseers positions
            </CourseDescription>
            
            <CourseMeta>
              <MetaItem>
                <MetaIcon>
                  <FaCalendarAlt />
                </MetaIcon>
                <MetaContent>
                  <MetaTitle>Start Date</MetaTitle>
                  <MetaValue>April 2, 2025</MetaValue>
                </MetaContent>
              </MetaItem>
              
              <MetaItem>
                <MetaIcon>
                  <FaClock />
                </MetaIcon>
                <MetaContent>
                  <MetaTitle>Duration</MetaTitle>
                  <MetaValue>1.5 Months</MetaValue>
                </MetaContent>
              </MetaItem>
              
              <MetaItem>
                <MetaIcon>
                  <FaUserClock />
                </MetaIcon>
                <MetaContent>
                  <MetaTitle>Timings</MetaTitle>
                  <MetaValue>6:30 AM - 8:30 AM & 7:00 PM - 9:00 PM</MetaValue>
                </MetaContent>
              </MetaItem>
              
              <MetaItem>
                <MetaIcon>
                  <FaGlobe />
                </MetaIcon>
                <MetaContent>
                  <MetaTitle>Mode</MetaTitle>
                  <MetaValue>Online Coaching</MetaValue>
                </MetaContent>
              </MetaItem>
              
              <MetaItem>
                <MetaIcon>
                  <FaRupeeSign />
                </MetaIcon>
                <MetaContent>
                  <MetaTitle>Fee</MetaTitle>
                  <MetaValue>₹9,900 + GST</MetaValue>
                </MetaContent>
              </MetaItem>
            </CourseMeta>
            
            <CourseAction>
              <Button to="/contact" variant="primary">Enroll Now</Button>
              <Button to="#syllabus" variant="secondary">View Syllabus</Button>
            </CourseAction>
          </CourseDetails>
        </CourseInfoBox>
      </div>
    </OverviewSection>
  );
};

export default CourseOverview;
